import { createApp } from 'vue'
import dayjs from 'dayjs'

import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'

import './styles/main.scss'
import './styles/tailwind.css'
import 'dayjs/locale/sv'

dayjs.locale('sv')

document.documentElement.classList.add('h-full')
document.body.classList.add('min-h-screen')

const appRoot = document.getElementById('app')
appRoot?.classList.add('min-h-screen')

const app = createApp(App)
app.use(router)
app.use(i18n)

// Wait for the router to resolve the initial URL before mounting. Otherwise the
// app mounts with route.path still '/', and useAuthWatcher runs its session check
// against '/' (non-public) and redirects to login before /design-system resolves.
void router.isReady().then(() => app.mount('#app'))
